var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "work-flow" }, [
    _c(
      "div",
      { staticClass: "work-flow__container default-content" },
      [
        _c("h2", { staticClass: "section-title" }, [
          _vm._v(_vm._s(_vm.locales.pages && _vm.locales.pages.how_it_works))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "work-flow__tabs" }, [
          _c(
            "a",
            {
              staticClass: "work-flow__tabs-item",
              class: _vm.termValue === 0 ? "work-flow__tabs-item--active" : "",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.changeTermValue(0)
                }
              }
            },
            [
              _vm._v(
                _vm._s(_vm.locales.pages && _vm.locales.pages.long_term_rent)
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "work-flow__tabs-item",
              class: _vm.termValue === 1 ? "work-flow__tabs-item--active" : "",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.changeTermValue(1)
                }
              }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.locales.pages && _vm.locales.pages.short_term_booking
                )
              )
            ]
          )
        ]),
        _vm._v(" "),
        _vm.termValue === 0
          ? [
              _c("div", { staticClass: "work-flow__list" }, [
                _c("div", { staticClass: "work-flow__list-item" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("h3", { staticClass: "work-flow__list-title" }, [
                    _vm._v(_vm._s(_vm.page.long_term_1_title_lang[_vm.lang]))
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "work-flow__list-text",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.page.long_term_1_content_lang[_vm.lang]
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "work-flow__list-item" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("h3", { staticClass: "work-flow__list-title" }, [
                    _vm._v(_vm._s(_vm.page.long_term_2_title_lang[_vm.lang]))
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "work-flow__list-text",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.page.long_term_2_content_lang[_vm.lang]
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "work-flow__list-item" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("h3", { staticClass: "work-flow__list-title" }, [
                    _vm._v(_vm._s(_vm.page.long_term_3_title_lang[_vm.lang]))
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "work-flow__list-text",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.page.long_term_3_content_lang[_vm.lang]
                      )
                    }
                  })
                ])
              ])
            ]
          : [
              _c("div", { staticClass: "work-flow__list" }, [
                _c("div", { staticClass: "work-flow__list-item" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("h3", { staticClass: "work-flow__list-title" }, [
                    _vm._v(_vm._s(_vm.page.short_term_1_title_lang[_vm.lang]))
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "work-flow__list-text",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.page.short_term_1_content_lang[_vm.lang]
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "work-flow__list-item" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("h3", { staticClass: "work-flow__list-title" }, [
                    _vm._v(_vm._s(_vm.page.short_term_2_title_lang[_vm.lang]))
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "work-flow__list-text",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.page.short_term_2_content_lang[_vm.lang]
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "work-flow__list-item" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("h3", { staticClass: "work-flow__list-title" }, [
                    _vm._v(_vm._s(_vm.page.short_term_3_title_lang[_vm.lang]))
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "work-flow__list-text",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.page.short_term_3_content_lang[_vm.lang]
                      )
                    }
                  })
                ])
              ])
            ],
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "theme-btn theme-btn--tertiary",
            attrs: { href: _vm.link }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.locales.pages && _vm.locales.pages.create_tenant_account
                ) +
                "\n      "
            ),
            _c("i", { staticClass: "icon-go-right" })
          ]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "work-flow__list-image-holder" }, [
      _c("i", { staticClass: "icon-search" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "work-flow__list-image-holder" }, [
      _c("i", { staticClass: "icon-upload" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "work-flow__list-image-holder" }, [
      _c("i", { staticClass: "icon-approved" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "work-flow__list-image-holder" }, [
      _c("i", { staticClass: "icon-search" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "work-flow__list-image-holder" }, [
      _c("i", { staticClass: "icon-upload" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "work-flow__list-image-holder" }, [
      _c("i", { staticClass: "icon-approved" })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b0d59ca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b0d59ca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/WorkFlow.vue
// module id = 582
// module chunks = 1